import React from 'react';
import {
    List, Datagrid, TextField, Edit, EditButton, ShowButton, Create, SimpleForm, TextInput
} from 'react-admin';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDataProvider } from 'react-admin';

const AddButton = ({ record }) => (
    <Button
        variant="contained"
        color="primary"
        size="small"
        component={Link}
        to={{
            pathname: 'addcluster',
            state: {
                record: {
                    id: record.id,
                    name: record.name,
                    level: record.nodeLevel
                }
            },
        }}
    >
        Add Cluster
    </Button>
);



const DeleteButton = ({record}) => {
    const dataProvider = useDataProvider();
    const handleDeleteCluster = () => {
        dataProvider('DELETE', 'nodes',{id:record.id});
    };
    return(
    <Button
        variant="contained"
        color="secondary"
        size="small"
        onClick={handleDeleteCluster}
        refresh="true"
    >
        Delete
    </Button>)
};
const DetailButton = ({ record }) => (
  
    <Button
        variant="contained"
        color="default"
        size="small"
        component={Link}
        
        to={{
           
            pathname: 'showcluster',
            state: {
                record: {
                    id: record.id,
                    name: record.name,
                    level: record.nodeLevel,
                    parent:record.parentId,
                  

                }
            },
        }}
        
    >
        Show
    </Button>
);
const EditsButton = ({ record }) => (
    <Button
        variant="contained"
        color="secondary"
        size="small"
        component={Link}
        to={{
            
            pathname: 'editcluster',
            state: {
                
                record: {
                    id: record.id,
                    level: record.nodeLevel,
                    name: record.name,
                    parent:record.parentId
                }
            },
        }}
    >
        Edit
    </Button>
  );

export const ListCluster = (props) => (
    <List {...props}>
        <Datagrid >
            <TextField label="ID" source="id" />
            <TextField label="Name" source="name" />
            <TextField label="Level" source="nodeLevel" />
            <TextField label="Parent" source="parentId.name" />
            <TextField label="Cannonical Name" source="cannonicalName" />
            <TextField label="Total Children" source="totalDescendants" />
            <TextField label="InActive Children" source="numOfInActiveDescendants" />
            <AddButton >
            </AddButton>
            {/* <EditsButton>
            </EditsButton> */}
            {/* <DeleteButton>
            </DeleteButton> */}
            <DetailButton>
            </DetailButton>   
            <EditButton   variant="contained"
        color="secondary"
        size="small" />       
        </Datagrid>
    </List>
);
export const CreateCluster = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput source="name" />
            <TextInput source="cannonicalName" />

        </SimpleForm>
    </Create>
     
);

export const ClusterEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <TextInput  label="Name" source="name" />
                <TextInput  label="Parent" source="parent.name"  disabled />
                <TextInput  label="Level" source="nodeLevel" disabled />               
            </SimpleForm>
        </Edit>
    )
};
